import React from 'react';
import { useNavigate } from 'react-router';
import ResetPasswordForm, {
  FormValues,
} from 'Account/components/views/ResetPasswordForm';
import { useResetPassword } from 'Account/hooks/auth';

type OwnProps = {
  token: string;
};
type Props = OwnProps;

const ResetPassword: React.FC<Props> = ({ token }) => {
  const navigate = useNavigate();
  const resetPasswordMutation = useResetPassword();

  const handleSubmit = (values: FormValues) => {
    resetPasswordMutation.mutate(
      { password: values.password, token },
      {
        onSuccess: () => {
          navigate('/login');
        },
      }
    );
  };
  return <ResetPasswordForm handleSubmit={handleSubmit} />;
};

export default ResetPassword;
